/**
 * Firebase Configuration
 * Stores and retrieves user plans
 */

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

// Firebase configuration
// Note: Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "demo-api-key",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "fitprep-demo.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fitprep-demo",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fitprep-demo.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abc123",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

/**
 * Save a plan (using localStorage for now)
 * @param {Object} plan - Plan object to save
 * @returns {Promise<string>} Plan ID
 */
export async function savePlan(plan) {
  // Use localStorage for fast, reliable storage
  const localPlans = JSON.parse(localStorage.getItem("fitprep_plans") || "[]");
  const planId = Date.now().toString();
  localPlans.push({ id: planId, ...plan, createdAt: new Date().toISOString() });
  localStorage.setItem("fitprep_plans", JSON.stringify(localPlans));
  console.log("Plan saved to localStorage");
  return planId;
}

/**
 * Get all saved plans from localStorage
 * @returns {Promise<Array>} Array of plans
 */
export async function getPlans() {
  // Use localStorage for fast, reliable storage
  const localPlans = JSON.parse(localStorage.getItem("fitprep_plans") || "[]");
  // Sort by date (most recent first)
  const sortedPlans = localPlans.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  console.log("Loaded plans from localStorage:", sortedPlans.length);
  return sortedPlans;
}

export default db;
